import React from "react"

import { Box, Button, Dialog, Divider, Typography } from "@mui/material"
import { Close, Notifications, Message } from "@mui/icons-material"
import { Link } from "react-router-dom"

interface WelcomeModalProps {
	open: boolean
	onClose: () => void
	unreadNotificationsCount: number
	unreadMessagesCount: number
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({
	open,
	onClose,
	unreadNotificationsCount,
	unreadMessagesCount,
}) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			fullWidth
			maxWidth="sm"
			PaperProps={{
				sx: {
					borderRadius: 2,
					py: 1,
				},
			}}
		>
			<Box sx={{ position: "relative", px: 3, pt: 2, pb: 3 }}>
				<Button
					onClick={onClose}
					startIcon={<Close fontSize="small" />}
					variant="outlined"
					size="small"
					sx={{
						position: "absolute",
						top: 16,
						right: 16,
						textTransform: "none",
						fontSize: "0.8rem",
						borderColor: "#E5E7EB",
						color: "#1F2937",
					}}
				>
					Chiudi
				</Button>

				<Typography
					variant="h5"
					textAlign="center"
					sx={{
						color: "#1E4B9A",
						fontWeight: 700,
						mt: 3,
					}}
				>
					Ciao
				</Typography>

				<Divider sx={{ my: 2, borderColor: "#2F5DB8" }} />

				<Box sx={{ display: "flex", flexDirection: "column", gap: 2, alignItems: "center", mb: 2 }}>
					<Box sx={{ display: "flex", gap: 2 }}>
						<Box
							sx={{
								width: 48,
								height: 48,
								borderRadius: "50%",
								backgroundColor: "#EF5350",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
							}}
						>
							<Notifications sx={{ color: "white" }} />
						</Box>
						<Box
							sx={{
								width: 48,
								height: 48,
								borderRadius: "50%",
								backgroundColor: "#4B5563",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
							}}
						>
							<Message sx={{ color: "white" }} />
						</Box>
					</Box>

					<Typography
						variant="body1"
						textAlign="center"
						sx={{ fontWeight: 600, color: "#4B5563" }}
					>
						Hai{" "}
						<Typography component="span" sx={{ color: "#EF5350", fontWeight: 700 }}>
							{unreadNotificationsCount}
						</Typography>{" "}
						nuove notifiche e{" "}
						<Typography component="span" sx={{ color: "#4B5563", fontWeight: 700 }}>
							{unreadMessagesCount}
						</Typography>{" "}
						messaggi non letti
					</Typography>
				</Box>

				<Divider sx={{ my: 2, borderColor: "#2F5DB8" }} />

				<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
					<Button
						component={Link}
						to="/notifications"
						variant="contained"
						color="secondary"
						disableElevation
						onClick={onClose}
						sx={{
							width: "100%",
							textTransform: "none",
							fontSize: "0.9rem",
							fontWeight: 600,
							py: 1,
						}}
					>
						Vedi le notifiche
					</Button>
					<Button
						component={Link}
						to="/messages"
						variant="outlined"
						color="secondary"
						onClick={onClose}
						sx={{
							width: "100%",
							textTransform: "none",
							fontSize: "0.9rem",
							fontWeight: 600,
							py: 1,
						}}
					>
						Vedi i messaggi
					</Button>
				</Box>
			</Box>
		</Dialog>
	)
}

export default WelcomeModal
